export * from "/__w/wiggot-web/wiggot-web/packages/web-components/queries/capital-gains/index.ts"